export const initSessionGUID = () => {
	let sessionGuid = '';
	const sessionGuidContainer = document.getElementById('SessionGuidContainer');

	if (sessionGuidContainer !== null) {
		const sessionGUIDInput = sessionGuidContainer.querySelector('input');

		if (sessionGUIDInput !== null) {
			sessionGuid = sessionGUIDInput.value || '';
		}
	}

	Object.defineProperty(window, '__sessionGuid__', {
		enumerable: false,
		configurable: false,
		writable: false,
		value: sessionGuid,
	});
};

export const initRequestVerificationToken = () => {
	let requestVerificationToken = '';
	const requestVerificationTokenContainer = document.getElementById('RequestVerificationTokenContainer');

	if (requestVerificationTokenContainer !== null) {
		const requestVerificationTokenInput = requestVerificationTokenContainer.querySelector('input');

		if (requestVerificationTokenInput !== null) {
			requestVerificationToken = requestVerificationTokenInput.value || '';
		}
	}

	Object.defineProperty(window, '__requestVerificationToken__', {
		enumerable: false,
		configurable: false,
		writable: false,
		value: requestVerificationToken,
	});
};
